import { apiGet } from "../../../utils.js";

export function getAllEstimateAPI(query, data) {
    let url = `/api/allMatrix/get-all-estimate?page=${query.page}&limit=${query.limit}`;
    if (query.sortBy) url += `&sortBy=${query.sortBy}`;
    if (query.sortDirection) url += `&sortDirection=${query.sortDirection}`;
    return apiGet(url, data);
}

